// Pure keyboard model: maps a key to a minimap action. Arrow keys step a focus hex along the
// pointy-top neighbour directions (left/right = west/east, up/down = the nearer diagonal).

import { EDGE_NEIGHBORS } from './minimapGeometry.js';

export type KeyAction =
  | { readonly kind: 'move'; readonly dq: number; readonly dr: number }
  | { readonly kind: 'activate' }
  | { readonly kind: 'zoom'; readonly dir: 1 | -1 }
  | { readonly kind: 'fit' }
  /** Jump the focus to the next own city (spec §5: `C` cycles own cities). */
  | { readonly kind: 'cycle-city' }
  | { readonly kind: 'none' };

const E = EDGE_NEIGHBORS[0] ?? [1, 0];
const W = EDGE_NEIGHBORS[3] ?? [-1, 0];
const SE = EDGE_NEIGHBORS[1] ?? [0, 1];
const SW = EDGE_NEIGHBORS[2] ?? [-1, 1];
const NW = EDGE_NEIGHBORS[4] ?? [0, -1];
const NE = EDGE_NEIGHBORS[5] ?? [1, -1];

/**
 * `shift` picks the second diagonal for up/down so every neighbour is reachable:
 * Down = south-east, Shift+Down = south-west, Up = north-west, Shift+Up = north-east.
 */
export function keyAction(key: string, shift = false): KeyAction {
  switch (key) {
    case 'ArrowRight':
      return { kind: 'move', dq: E[0], dr: E[1] };
    case 'ArrowLeft':
      return { kind: 'move', dq: W[0], dr: W[1] };
    case 'ArrowDown': {
      const d = shift ? SW : SE;
      return { kind: 'move', dq: d[0], dr: d[1] };
    }
    case 'ArrowUp': {
      const d = shift ? NE : NW;
      return { kind: 'move', dq: d[0], dr: d[1] };
    }
    case 'Enter':
    case ' ':
      return { kind: 'activate' };
    case '+':
    case '=':
      return { kind: 'zoom', dir: 1 };
    case '-':
    case '_':
      return { kind: 'zoom', dir: -1 };
    case '0':
      return { kind: 'fit' };
    case 'c':
    case 'C':
      return { kind: 'cycle-city' };
    default:
      return { kind: 'none' };
  }
}
